var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Dropdown } from '../dropdown';
import NotificationDot from './notification-dot';
import { destructiveItemStaticStyle } from './styles';
function Item(_a) {
    var { iconLeft, iconRight, label, showNotificationDot = false, variant = 'primary' } = _a, restProps = __rest(_a, ["iconLeft", "iconRight", "label", "showNotificationDot", "variant"]);
    function renderDecorLeft() {
        return (_jsxs(_Fragment, { children: [showNotificationDot && _jsx(NotificationDot, {}), iconLeft] }));
    }
    return (_jsx(Dropdown.Item, Object.assign({ css: variant === 'destructive' ? destructiveItemStaticStyle : {}, decorLeft: renderDecorLeft(), decorRight: iconRight, label: label }, restProps)));
}
export default Item;
